import { NgModule } from '@angular/core';
import { VafLogResponsetModal } from './vaf-log-response-modal.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VafLogResponseComponentModule } from '../../components/vaf-log-response-component/vaf-log-response-component.component.module';
import { TableExtractionComponentModule } from '../../components/table-extraction/table-extraction.component.module';

@NgModule({
    declarations: [
        VafLogResponsetModal
    ],
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        VafLogResponseComponentModule,
        TableExtractionComponentModule
    ],
    exports: [
        VafLogResponsetModal
    ]
})
export class VafLogResponsetModalModule { }